
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 19","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M2.13 2.13a6.417 6.417 0 119.074 9.074 6.417 6.417 0 01-9.075-9.075zm4.537-.38a4.917 4.917 0 100 9.833 4.917 4.917 0 000-9.833z","clip-rule":"evenodd"}}),_c('path',{attrs:{"fill-rule":"evenodd","d":"M3.65 14.6a.75.75 0 01.75-.75h4.534a.75.75 0 010 1.5H4.4a.75.75 0 01-.75-.75zm0 2.267a.75.75 0 01.75-.75h4.534a.75.75 0 010 1.5H4.4a.75.75 0 01-.75-.75z","clip-rule":"evenodd"}}),_c('path',{attrs:{"fill-rule":"evenodd","d":"M6.667 16.117a.75.75 0 01.75.75V18a.75.75 0 01-1.5 0v-1.133a.75.75 0 01.75-.75zM4.436 7.268a.75.75 0 011.061 0l1.7 1.7c.14.14.22.331.22.53v2.834a.75.75 0 01-1.5 0V9.809l-1.48-1.48a.75.75 0 010-1.061z","clip-rule":"evenodd"}}),_c('path',{attrs:{"fill-rule":"evenodd","d":"M8.897 7.268a.75.75 0 010 1.06l-1.7 1.7a.75.75 0 11-1.06-1.06l1.7-1.7a.75.75 0 011.06 0z","clip-rule":"evenodd"}})])
          )
        }
      }
    